import { render, staticRenderFns } from "./SetAmount.vue?vue&type=template&id=4d43ec67&scoped=true&"
import script from "./SetAmount.vue?vue&type=script&lang=js&"
export * from "./SetAmount.vue?vue&type=script&lang=js&"
import style0 from "./SetAmount.vue?vue&type=style&index=0&id=4d43ec67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43ec67",
  null
  
)

export default component.exports